/*
This action file conatin the action to show the alerts.
*/
export const NOTIFICATION_ADD = 'NOTIFICATION_ADD';

export const addNotification = (text, status) => {
  return (dispatch, getState) => {
    status = status || 'ok';
    dispatch({
      type: NOTIFICATION_ADD,
      text: text,
      time: Date.now(),
      status: status
    });
  };
};



// WEBPACK FOOTER //
// ./src/Actions/notifications.js